import Block from '../block'

export default class Wishlist extends Block {
	static title = 'wishlist'

	init() {
		this.productId = this.element.getAttribute('data-product-id')
		this.icon = this.getElement('icon')

		this.element.addEventListener('click', () => this.clickHandler())
	}

	clickHandler() {
		if (this.element.hasAttribute('data-wishlist-product-id')) {
			this.removeFromWishlist()
			return
		}

		this.addToWishlist()
	}

	addToWishlist() {
		this.setLoading()

		const payload = new FormData()
		payload.append('product_id', this.productId)
		payload.append('ajax', true)
		payload.append('wishlist_add', true)

		fetch('/account', {
			method: 'POST',
			body: payload,
			credentials: 'same-origin',
		})
			.then(response => response.json())
			.then(json => this.handleAddResponse(json))
			.catch(error => this.handleError(error))
	}

	handleAddResponse(json) {
		if (json.error || !json.wishlist_id) {
			this.setRemoved()
			return
		}

		this.setAdded()
		this.element.setAttribute('data-wishlist-product-id', json.wishlist_id)
	}

	handleRemoveResponse(json) {
		this.setRemoved()

		if (json.error) {
			this.setAdded()
			return
		}

		this.element.removeAttribute('data-wishlist-product-id')
	}

	removeFromWishlist() {
		this.setLoading()

		const payload = new FormData()
		payload.append(
			'wishlist_product_id',
			this.element.getAttribute('data-wishlist-product-id')
		)
		payload.append('ajax', true)
		payload.append('wishlist_delete', true)

		fetch('/account', {
			method: 'POST',
			body: payload,
			credentials: 'same-origin',
		})
			.then(response => response.json())
			.then(json => this.handleRemoveResponse(json))
			.catch(error => this.handleError(error))
	}

	setLoading() {
		if (!this.icon) {
			return
		}

		this.icon.classList.remove('fas')
		this.icon.classList.remove('fa-heart')

		this.icon.classList.add('fa-circle-notch')
		this.icon.classList.add('fa-spin')
		this.icon.classList.add('fal')
	}

	setAdded() {
		if (!this.icon) {
			return
		}

		this.icon.classList.add('fa-heart')
		this.icon.classList.add('fas')

		this.icon.classList.remove('fal')
		this.icon.classList.remove('fa-spin')
		this.icon.classList.remove('fa-circle-notch')
	}

	setRemoved() {
		if (!this.icon) {
			return
		}

		this.icon.classList.add('fa-heart')
		this.icon.classList.add('fal')

		this.icon.classList.remove('fas')
		this.icon.classList.remove('fa-spin')
		this.icon.classList.remove('fa-circle-notch')
	}
}
